import { Reservation, ReservationStatus } from "../dashboard/types";

export const getStatusBadge = (status: Reservation['status']) => {
    let colorClass = '';
    switch (status) {
      case ReservationStatus.BOOKED:
        colorClass = 'bg-yellow-100 text-yellow-800';
        break;
      case ReservationStatus.PAID:
        colorClass = 'bg-green-100 text-green-800';
        break;
      case ReservationStatus.CONFIRMED:
        colorClass = 'bg-blue-100 text-blue-800';
        break;
      case ReservationStatus.CHECKED_IN:
        colorClass = 'bg-purple-100 text-purple-800';
        break;
      case ReservationStatus.CANCELLED:
        colorClass = 'bg-red-100 text-red-800';
        break;
      case ReservationStatus.COMPLETED:
        colorClass = 'bg-black text-white';
        break;
    }
    return (<span className={`rounded-lg px-2 py-1 ${colorClass}`}>{status.replace(/_/g, ' ').toUpperCase()}</span>);
  }
